function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { ErrorUnavailable } from '../api';
import { ErrorBadRequest } from '../api/errors';
import { clearError, clearWarning, useFormContext } from '../state/form';
import { BadRequestErrorMessage, NetworkErrorMessage, ServiceUnavailableMessage, UserWarningMessage } from './messages';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DisplayMessages(_ref) {
  var legacyUrl = _ref.legacyUrl;

  var _useFormContext = useFormContext(),
      _useFormContext$state = _useFormContext.state,
      error = _useFormContext$state.error,
      warnings = _useFormContext$state.warnings,
      dispatchForm = _useFormContext.dispatch;

  var clearWarningDispatch = function clearWarningDispatch() {
    return dispatchForm(clearWarning());
  };

  var clearErrorDispatch = function clearErrorDispatch() {
    return dispatchForm(clearError());
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      initialized = _useState2[0],
      setInitialized = _useState2[1]; // In case of server-side rendering


  useEffect(function () {
    return setInitialized(true);
  }, []);
  return initialized && /*#__PURE__*/_jsxs(_Fragment, {
    children: [error !== null && (error instanceof ErrorUnavailable ? /*#__PURE__*/_jsx(ServiceUnavailableMessage, {
      serverMessage: error.message,
      onClose: clearErrorDispatch
    }) : error instanceof ErrorBadRequest ? /*#__PURE__*/_jsx(BadRequestErrorMessage, {
      onClose: clearErrorDispatch
    }) : /*#__PURE__*/_jsx(NetworkErrorMessage, {
      onClose: clearErrorDispatch
    })), warnings !== null && warnings.length > 0 && /*#__PURE__*/_jsx(UserWarningMessage, {
      warnings: warnings,
      onClose: clearWarningDispatch
    })]
  });
}
DisplayMessages.propTypes = {
  legacyUrl: PropTypes.string
};
DisplayMessages.defaultProps = {
  legacyUrl: null
};